<!--店铺下拉框多选-->
<script>
import api from "@/api/projectApi";

export default {
  name: 'brandMultipleSelect.vue',
  props: ['brandIdList'],
  mounted() {
    this.loadData()
  },
  data() {
    return {
      selectOption: []
    }
  },
  methods: {
    selectChange() {
      this.$emit('update:brandIdList', this.brandIdList)
    },

    clear() {
      this.$emit('update:brandIdList', [])
    },

    loadData() {
      this.$http.post(api.snCompanyBrand.getBrandListUrl, {}).then(res => {
        this.selectOption = res.data.data
      })
    },
  }
}
</script>

<template>
  <div>
    <el-select v-model="brandIdList"
               @change="selectChange"
               @clear="clear"
               :multiple="true"
               :clearable="true"
               placeholder="请选择"
               style="width: 100%;"
    >
      <el-option v-for="item in selectOption"
                 :key="item.id"
                 :label="item.brandName"
                 :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>
